import { useWatch } from "react-hook-form";
import { useWorkflowForm } from "../context/workflows-editor-workflows-context";
import { useMemo } from "react";

/**
 * Hook to retrieve the current node data from the form.
 * This watches the form state and returns live data for a specific node.
 */
export function useNodeData<T = unknown>(nodeId: string): T | null {
  const form = useWorkflowForm();

  const nodes = useWatch({
    control: form.control,
    name: "workflow.definition.nodes",
  });

  return useMemo(() => {
    if (!nodes || !Array.isArray(nodes)) {
      return null;
    }

    const node = nodes.find((n) => n?.id === nodeId);
    return node?.data as T ?? null;
  }, [nodes, nodeId]);
}
